import { Dropdown } from '@carbon/react';
import { SelectFilterProps } from '../types';

type DropdownItem = { value: string; label: string };

/**
 * Single-select filter component using Carbon Dropdown.
 * Allows selecting one value from a list of options.
 * @param {SelectFilterProps} props - Component props
 * @param {string} props.id - Unique identifier for the filter
 * @param {string} props.label - Display label for the filter
 * @param {string | null} props.value - Currently selected value
 * @param {Function} props.onChange - Callback when selection changes
 * @param {Array} props.options - Available options with value/label pairs
 * @param {string} [props.placeholder] - Placeholder text (default: 'All')
 * @return {JSX.Element} The select filter element
 */
export function SelectFilter({
  id,
  label,
  value,
  onChange,
  options,
  placeholder = 'All',
}: SelectFilterProps) {
  const items: DropdownItem[] = [{ value: '', label: placeholder }, ...options];
  const selectedItem = items.find((item) => item.value === value) || items[0];

  return (
    <Dropdown
      id={id}
      titleText={label}
      label={selectedItem.label}
      items={items}
      selectedItem={selectedItem}
      itemToString={(item: DropdownItem | null) => item?.label ?? ''}
      onChange={({ selectedItem }: { selectedItem: DropdownItem | null }) =>
        onChange(selectedItem?.value || null)
      }
    />
  );
}
